import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles<Theme>(() => ({
  menuItem: {
    padding: "6px 10px",
  },
}));
